// extracted by mini-css-extract-plugin
export var image = "WeddingModalForm-module--image--057dd";
export var modalContainer = "WeddingModalForm-module--modalContainer--91908";
export var modalFormButton = "WeddingModalForm-module--modalFormButton--562bb";
export var modalImage = "WeddingModalForm-module--modalImage--38036";